import { css } from '@emotion/react';
import { breakpoints } from '@frontend/responsiveness';
import { theme } from '@frontend/theme';

export const dashboardChartStyle = css`
  border-radius: ${theme.borderRadius.medium};
  border: 1px solid ${theme.colors.neutral20};

  .chart-content {
    border: none;
    justify-content: space-between;
  }
`;

export const filtersStyles = {
  mainWrapper: css`
    display: flex;
    flex-wrap: wrap;
    gap: ${theme.spacing(2)};
    margin-bottom: ${theme.spacing(3)};
    position: relative;
  `,

  clearAll: css`
    color: ${theme.colors.text.interactive};
    font-weight: ${theme.font.weight.bold};
  `,

  filteredBadge: css`
    position: relative;

    &::after {
      background-color: ${theme.colors.text.interactive};
      border-radius: ${theme.borderRadius.full};
      content: '';
      height: ${theme.spacing(1.25)};
      left: ${theme.spacing(3)};
      position: absolute;
      top: ${theme.spacing(1)};
      width: ${theme.spacing(1.25)};
    }
  `,

  traySection: css`
    display: flex;
    flex-direction: column;
    gap: ${theme.spacing(2)};
  `,
};

export const tableStyles = css`
  height: 100%;
  padding-top: ${theme.spacing(1)};

  > [class$='TableToolbar']:first-of-type {
    padding: 0;
  }
`;

export const pageStyles = {
  tabPanel: css`
    flex: 1;
    overflow: auto;
  `,

  panelsWrapper: css`
    display: flex;
    flex-direction: column;
    flex: 1;
    overflow: hidden;
    position: relative;
  `,

  customTabSelect: css`
    button[aria-selected='true'] {
      color: ${theme.colors.text.interactive};
      font-weight: ${theme.font.weight.semibold};
    }
  `,

  numberSearch: (isMobile?: boolean) => css`
    flex: ${isMobile ? 'none' : 1};
    margin-bottom: ${isMobile ? theme.spacing(1) : 0};
    width: ${isMobile ? '100%' : 'auto'};
  `,

  tableFullHeight: css`
    height: auto;

    > div:first-of-type {
      display: flex;
      flex-direction: column;
    }
  `,
};

export const dropdownStyledPopover = (label: string) => css`
  flex-direction: row-reverse;
  justify-content: space-between;
  padding: ${theme.spacing(0.25, 2)};
  position: relative;
  width: 100%;
  max-width: none;

  .location-caret {
    display: none;
  }

  .dropdown-icon {
    transition: transform 0.2s ease-in-out;

    &.open {
      transform: rotate(180deg);
    }
  }

  &:focus {
    border: 1px solid ${theme.colors.primary40};
    outline: none;
  }

  &:after {
    background-color: ${theme.colors.white};
    color: ${theme.font.colors.subdued};
    content: '${label}';
    font-size: ${theme.font.size.small};
    left: ${theme.spacing(1.5)};
    position: absolute;
    top: 0;
    transform: translateY(-50%);
  }
`;

export const chartWithDataCardsStyles = {
  outerContainer: css`
    display: flex;
    flex-direction: column;
    gap: ${theme.spacing(2)};
    padding: ${theme.spacing(2)};
    border: 1px solid ${theme.colors.neutral20};
    border-radius: ${theme.spacing(1)};
  `,
  heading: css`
    display: flex;
    justify-content: space-between;
    align-items: center;
  `,
  headingLeft: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  innerWrapper: css`
    display: flex;
    flex-direction: column;
    gap: ${theme.spacing(2)};
  `,
  cardsGrid: css`
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: ${theme.spacing(2)};

    @media (max-width: ${breakpoints.large.max}px) {
      grid-template-columns: repeat(2, 1fr);
    }

    @media (max-width: ${breakpoints.medium.max}px) {
      grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    }
  `,
};
